import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'updatedAtDateFormat',
    pure: true,
    standalone: false
})
export class UpdatedAtDateFormatPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: any, ...args: unknown[]): string {
    const fromDate = new Date(value);
    const diffInDays = Math.floor((new Date().getTime() - fromDate.getTime()) / (1000 * 3600 * 24));

    let translationKey = 'zero';
    if (diffInDays === 1) {
      translationKey = 'one';
    } else if (diffInDays > 1) {
      translationKey = 'other';
    }

    return this.translateService.instant('modules.anomalies.admin.grid.dayDifference.' + translationKey, { count: diffInDays });
  }
}